import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/app/(marketing)/tools/markdown-viewer/page-client.tsx");
